import { render } from "./FormMultiselect.vue?vue&type=template&id=5767e588"
import script from "./FormMultiselect.vue?vue&type=script&lang=js"
export * from "./FormMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__